import { render } from "./MemberEdit-View.vue?vue&type=template&id=0b4aecee"
import script from "./MemberEdit-View.vue?vue&type=script&lang=js"
export * from "./MemberEdit-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__